import React from "react";
import { Link } from "react-router-dom";
import Bg from "../../images/shapes/shape_net_ico_hero_section_bg.svg";
import icon1 from "../../images/services/coin-bg.png";

const Hero = () => {
  return (
    <section
      className="ico_hero_section section_decoration text-center"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <div className="bonus-info mt-2 mb-5">
              <h5 className="mb-2">Join Today and Unlock Your Rewards</h5>
              <p className="mb-3">
                When you join TopCoin UK, you will receive 10,000 TopCoin as part of your starter package. These
                rewards are unlocked once you reach a total of 20,000 TopCoin
                through normal participation.
              </p>

              <ul
                className="btns_group unordered_list justify-content-center mt-4 p-0"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay="100"
              >
                <li>
                  <Link className="ico_creative_btn" to="/sign_up">
                    <span className="btn_wrapper px-5 py-3">
                      <span className="btn_label">
                        Join Now & Get Your TopCoin
                      </span>
                      <span className="btn_icon_right">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          fill="currentColor"
                        >
                          <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                        </svg>
                      </span>
                    </span>
                  </Link>
                </li>
              </ul>
              </div>
        <img loading="lazy" src={icon1} alt="ICO Site Logo" />

        <div className="row justify-content-center pb-2">
          <div className="col-lg-10">
            <h1
              className="hero_title mb-3"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              Welcome to TopCoin UK!
            </h1>
            <h3 className="" data-aos="fade-up" data-aos-duration="800">
              "Get Free TopCoin Every Time You Shop"
            </h3>

            <p className="mb-0">
              TopCoin UK is the UK's smartest rewards and loyalty system. When
              you shop at participating businesses around the world, you earn
              free TopCoin. Customers from anywhere can collect TopCoin, unlock
              their wallets, and redeem real cash rewards, with absolutely no
              strings attached.
            </p>

            <div className="bonus-info mt-4">
              <p className="mb-2 mt-5" style={{fontWeight:600}}>How Your Bonus TopCoin Works</p>
              <ul className="ps-4" style={{display:"flex", justifyContent:"center"}}>
                <li className="mb-2">
                  Bonus TopCoin is added to your main TopCoin balance as "Bonus
                  TopCoin."
                </li>
              </ul>
              <p className="mb-2"  style={{fontWeight:600}}>
                This Bonus TopCoin is an additional reward given to support your
                progress.
              </p>
              <ul className=" ps-4 " style={{display:"flex", justifyContent:"center"}}>
                <li className="mb-2">
                  Bonus TopCoin does not increase, unlock, or speed up your cash
                  bonus reward levels.
                </li>
              </ul>
              <p className="mb-2"  style={{fontWeight:600}}>
                Your cash bonus rewards are based only on your original TopCoin
                earnings, not your bonus amount.
              </p>
              <ul className="ps-4" style={{display:"flex", justifyContent:"center"}}>
                <li className="mb-2">
                  Bonus TopCoin can only be withdrawn together with your
                  original TopCoin.
                </li>
              </ul>
              <p className="mb-2"  style={{fontWeight:600}}>It cannot be withdrawn separately.</p>
              <ul className="ps-4" style={{display:"flex", justifyContent:"center"}}>
                <li className="mb-2">
                  Additional "Bonus TCUK" is provided at certain stages. These
                  are extra promotional rewards given by TopCoin UK.
                </li>
              </ul>
              <p className="mb-2"  style={{fontWeight:600}}>How Bonus TopCoin Helps You</p>
              <ul className="ps-4" style={{display:"flex", justifyContent:"center"}}>
                <li>
                  When you reach each Cash Wallet level, your Bonus TopCoin
                  helps increase the share of that wallet you may receive.
                </li>
              </ul>
              <p className="mb-2"  style={{fontWeight:600}}>
                It strengthens your position when a wallet unlocks, giving you a
                better return.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
